import React from 'react'
import { Link } from 'react-router-dom'
import './questionbank.css'
import BackButton from '../../components/backButton'

const QuestionBank = () => {
  return (
    <div className='qb_page'>
      <BackButton to='/' />
      <div className='qb_header'>
        <h1 className='qb_title'>Question Bank</h1>
        <p className='qb_subtitle'>
          Study material for the Computer Competency Test Examination,
          chapter by chapter. Choose a language to begin.
        </p>
      </div>

      {/* CCTE publishes one English question bank, so there is one tile.
          (The Hindi tile here was a plain <div> wired to nothing.) */}
      <div className='qb_lang_grid'>
        <Link className='qb_lang' to='/subject-page'>
          English
          <span className='qb_lang_sub'>अंग्रेज़ी</span>
        </Link>
      </div>

      <p className='qb_note'>
        <b>Note:</b> The question bank is revised and updated continuously.
        Please visit this page regularly for the latest questions.
      </p>
    </div>
  )
}

export default QuestionBank
